export const FRONTEND_STATE_STREETVIEW_SET_LOCATION = 'FRONTEND_STATE_STREETVIEW_SET_LOCATION';
export const FRONTEND_STATE_STREETVIEW_OFF = 'FRONTEND_STATE_STREETVIEW_OFF';
export const FRONTEND_STATE_STREETVIEW_ON = 'FRONTEND_STATE_STREETVIEW_ON';
